.SidebarContainer {
  display: flex;
  flex-flow: row nowrap;

  & main {
    width: 100vw;
    @media (min-width: 992px) {
      width: calc(100vw - 280px);
      padding: 1rem 0;
    }
  }
}

.ToggleContainer {
  position: fixed;
  top: 10px;
  right: 59px;
  z-index: 1000;
  cursor: pointer;

  @media (min-width: 992px) {
    display: none;
  }

  img {
    width: 36px;
    height: 36px;
  }
}
